import Axios from "axios";

const isForplay = typeof window !== "undefined" && window.location.hostname.includes("forplay.co.il");

const axios = Axios.create({
  baseURL: isForplay ? "https://play.forplay.co.il" : process.env.REACT_APP_API_URL,
});

export const BASE_URL = isForplay ? "https://play.forplay.co.il" : process.env.REACT_APP_API_URL;

export const MEDIA_URL = isForplay ? "https://play.forplay.co.il" : process.env.REACT_APP_MEDIA_URL;

export default axios;

// import Axios from "axios";

// const axios = Axios.create({
//   baseURL: "https://dev.4-play.io",
// });

// export const BASE_URL = "https://dev.4-play.io";

// // export const MEDIA_URL = "https://4play.s3.il-central-1.amazonaws.com";
// // export const MEDIA_URL = "https://4play-dev.s3.il-central-1.amazonaws.com";
// export const MEDIA_URL = "https://dev-v-r2.4-play.io";

// export default axios;
